import { BesChannelsAdapter } from './adapter';
import { ADAPTER_CONFIG } from './adapterHelper';
import { AdapterManager } from './adapterManager';
import { ITrackParams } from './types';

export class AdapterService {
    private adapterManager = new AdapterManager();
    private initialized = false;
    // 缓存初始化 Promise 避免并发问题
    private initPromise: Promise<void> | null = null;

    public async init(): Promise<void> {
        if (this.initialized) {
            return;
        }
        if (this.initPromise) {
            return this.initPromise;
        }

        this.initPromise = this._doInit();

        try {
            await this.initPromise;
        } finally {
            this.initPromise = null;
        }
    }

    private async _doInit(): Promise<void> {
        try {
            this.registerAllAdapters();
            await this.adapterManager.initAll();
        } catch (error) {
            console.log('[AdapterService:init] ', error);
        }
        this.initialized = true;
    }

    public async track(params: ITrackParams, eventName: string): Promise<void> {
        if (!this.initialized) {
            return;
        }
        try {
            await this.adapterManager.track(params, eventName);
        } catch (error) {
            console.log('[AdapterService:track] ', error);
        }
    }

    private registerAllAdapters() {
        // 注册致趣埋点适配器，后续可以扩展其他三方服务
        if (ADAPTER_CONFIG.besChannels?.enabled) {
            this.adapterManager.register(new BesChannelsAdapter(), ADAPTER_CONFIG.besChannels.config);
        }
    }

    public unregisterAdapter(name: string) {
        this.adapterManager.unregister(name);
    }
}

export const adapterService = new AdapterService();
